import { useIntl } from "react-intl";

import { CircularProgress } from "@/components/CircularProgress/CircularProgress";
import { Skeleton } from "@/components/Skeleton/Skeleton";

export const HotelBookingSuccessSkeleton = () => {
  const intl = useIntl();

  return (
    <div className="space-y-2.5 overflow-y-hidden">
      <div className="section-card flex flex-col gap-6">
        <div className="flex items-center justify-between gap-2 py-4.5 pe-2.5">
          <div className="flex flex-col gap-1">
            <div className="text-xl font-semibold text-text-primary">
              {intl.formatMessage({
                defaultMessage: "Booking in progress",
                description: "Title of hotel booking success screen",
              })}
            </div>
            <div className="text-sm text-text-tertiary">
              {intl.formatMessage({
                defaultMessage: "This might take few seconds",
                description: "Subtitle of hotel booking success screen",
              })}
            </div>
          </div>
          <CircularProgress size={44} />
        </div>
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={index} height={64} />
        ))}
        <Skeleton height={88} />
      </div>
      <div className="section-card">
        <Skeleton height={200} />
      </div>
    </div>
  );
};
